var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"ar-companion-home-page"}},[(!_vm.isCompanionMode)?[_c('PleaseWait')]:[_c('div',{staticClass:"standard-heading companion-home"},[_vm._v("Companion")]),_c('ChooseAuth')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }